export const APP_STORAGE_PREFIX = 'shinai:'

function browserStorage(name) {
    if (typeof window === 'undefined') return { name, storage: null, error: null }
    try {
        return { name, storage: window[name], error: null }
    } catch (error) {
        return { name, storage: null, error }
    }
}

function storageTargets(options) {
    if (!options) {
        return [browserStorage('localStorage'), browserStorage('sessionStorage')]
    }
    return [
        { name: 'localStorage', storage: options.localStorage || null, error: null },
        { name: 'sessionStorage', storage: options.sessionStorage || null, error: null },
    ]
}

export function clearApplicationData(options) {
    const removedKeys = []
    const errors = []

    for (const target of storageTargets(options)) {
        if (target.error) {
            errors.push({ storage: target.name, error: target.error })
            continue
        }
        if (!target.storage) continue

        let keys = []
        try {
            for (let index = 0; index < target.storage.length; index += 1) {
                const key = target.storage.key(index)
                if (String(key || '').startsWith(APP_STORAGE_PREFIX)) keys.push(key)
            }
        } catch (error) {
            errors.push({ storage: target.name, error })
            continue
        }

        for (const key of keys) {
            try {
                target.storage.removeItem(key)
                removedKeys.push(key)
            } catch (error) {
                errors.push({ storage: target.name, key, error })
            }
        }
    }

    return { removedKeys, errors }
}
